import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { Row } from 'react-bootstrap';
import classNames from 'classnames';
import Col from 'components/core/Col';
import ComponentContainer from 'components/core/ComponentContainer';

class ConfigGrid extends Component {
  static propTypes = {
    params: PropTypes.object,
    id: PropTypes.string,
    className: PropTypes.string,
    fullwidth: PropTypes.bool,
    gutterSpacing: PropTypes.string,
    configPath: PropTypes.string.isRequired
  }

  static contextTypes = {
    flux: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired
  }

  constructor(){
    super();
    this.loadingComponents = {};
  }

  state = {
    componentsToBeLoaded: [],
    pageGridComponents: [[[]]]
  }

  componentWillMount() {
    const {
      configPath,
      gutterSpacing: pageGutterSpacing
    } = this.props;

    const { config } = this.context;

    const rows = _.get(config, configPath, []);
    let componentsToBeLoaded = [];

    const initialPageGrid = rows.map((row, i) => {
      const { gutterSpacing: rowGutterSpacing, cols } = row;

      const currentRow = {
        cols: cols.map((col, j) => {
          const { gutterSpacing: colGutterSpacing, spans, components } = col;

          return ({
            gutterSpacing: colGutterSpacing || rowGutterSpacing || pageGutterSpacing,
            spans,
            components: components.map((component, k) => {
              const componentDetails = {
                row: i,
                col: j,
                position: k,
                componentDefinition: component,
                componentInstanceId: `${configPath}[${i}].cols[${j}].components[${k}]`,
                spans
              };

              // Get load order index. If defined (and greater than zero) add the component to componentsToBeLoaded and return null.
              // Otherwise return the component wrapped in a component container
              if (component.FRN_loadOrderIndex) {
                const loadOrderIndex = component.FRN_loadOrderIndex;

                if (componentsToBeLoaded[loadOrderIndex]) {
                  componentsToBeLoaded[loadOrderIndex].push(componentDetails);
                } else {
                  componentsToBeLoaded[loadOrderIndex] = [componentDetails];
                }

                return null;
              } else {
                return this.createComponentContainer(componentDetails);
              }
            })
          });
        }),
        hasStickyChild: cols.some((col) => {
          const { components } = col;

          return components.some((component) => component.FRN_moduleSticky);
        })
      };

      return currentRow;
    });

    // Remove all null spaces from the componentsToBeLoaded array. The elements will remain in priority order, there
    // just won't be gaps between these elements.
    componentsToBeLoaded = componentsToBeLoaded.filter(elements => elements);

    this.setState({
      pageGridComponents: initialPageGrid,
      componentsToBeLoaded
    });
  }

  createComponentContainer(componentOptions = {}) {
    const {
      params = {}
      } = this.props;
    const {
      row,
      col,
      position,
      componentDefinition,
      componentInstanceId,
      spans
      } = componentOptions;

    this.loadingComponents[componentInstanceId] = true;

    return (
      <ComponentContainer
        key={row + '.' + col + '.' + position}
        componentDefinition={componentDefinition}
        componentInstanceId={componentInstanceId}
        onComponentRender={this.registerChildComponentRendered.bind(this)}
        params={params}
        spans={spans} />
    );
  }

  loadNextComponents() {
    const {
      pageGridComponents,
      componentsToBeLoaded
      } = this.state;

    let updatedComponentList;

    //Check if there are any more components to load in the current ConfigGrid
    const componentsToLoadNext = componentsToBeLoaded.shift();

    // If there are still components to load, turn them into components and send them to their parent columns
    if (componentsToLoadNext) {
      _.forEach(componentsToLoadNext, (component) => {
        updatedComponentList = _.clone(pageGridComponents[component.row].cols[component.col].components);
        updatedComponentList[component.position] = this.createComponentContainer(component);

        pageGridComponents[component.row].cols[component.col].components = updatedComponentList;
      });

      this.setState({
        pageGridComponents
      });
    }
  }

  // Child components will let the parent know when they have received their data and rendered to the screen
  registerChildComponentRendered(componentInstanceId) {
    const {
      componentsToBeLoaded
    } = this.state;

    // Remove the current component from the list of components registered as loading
    this.loadingComponents = _.omit(this.loadingComponents, componentInstanceId);

    //If all current children have rendered and there are still components to load, then load them
    if (!_.size(this.loadingComponents) && componentsToBeLoaded.length) {
      this.loadNextComponents();
    }
  }

  render() {
    const {
      className,
      fullwidth,
      id
    } = this.props;
    const {
      pageGridComponents: rows
    } = this.state;

    return (
      <div id={id}
        className={classNames('PageGrid', className, {
          container: !fullwidth
        })}>
        {rows.map((row, i) => {
          const { cols, hasStickyChild } = row;

          return (
            <Row key={i} className={classNames({ 'row--hasStickyChild': hasStickyChild })}>
              {cols.map((col, j) => {
                const { spans = {}, gutterSpacing, components: componentDefinitions = [] } = col;
                const colClassName = classNames({[`frn-u-grid-gutter-${gutterSpacing}`]: gutterSpacing});

                return (
                  <Col className={colClassName} key={i + '.' + j} spans={spans} >
                    {componentDefinitions}
                  </Col>
                );
              })}
            </Row>
          );
        })}
      </div>
    );
  }
}

export default ConfigGrid;



// WEBPACK FOOTER //
// ./app/components/core/ConfigGrid.js